module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Mask Text Input Settings</span></div>\r\n<div class=\"prop-mask\">\r\n    <div class=\"row\" style=\"margin-bottom: 0px\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Mask</label> \r\n            <div>\r\n                <input type=\"text\" name=\"mask\" value=\"")
    ; __append(escapeFn( mask ))
    ; __append("\" />\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"margin-top: 0px\">\r\n        <div class=\"col-md-12\">+ = Alpha</div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\"># = Numeric</div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">? = Alpha or numeric</div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">* = Any character</div>\r\n    </div>\r\n</div>")
  }
  return __output;

}